import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';

import { getPath } from '../steps';
import { subscribe } from './TallyErrors';

const useStyles = makeStyles(theme => ({
  root: {
    '& button': {
      textAlign: 'left',
    },
  },
  badge: {
    paddingRight: theme.spacing(2),
  },
}));

let maxStep = 0;

type FormStepsProps = {
  step: number,
  steps: string[],
};

const FormSteps = ({ step, steps }: FormStepsProps) => {
  const classes = useStyles();
  const history = useHistory();
  const [tallies, setTallies] = React.useState({} as { [key: string]: any });
  React.useEffect(() => subscribe(setTallies), []);

  if (maxStep < step) {
    maxStep = step;
  }

  return (
    <Stepper className={classes.root} nonLinear orientation="vertical" activeStep={step}>
      {steps.map((title, index) => (
        <Step key={title}>
          <StepButton
            completed={index < step}
            onClick={() => {
              history.push(getPath(steps, index));
            }}
          >
            <Badge badgeContent={index <= maxStep ? tallies[title] : 0} className={classes.badge} color="secondary">
              {title}
            </Badge>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
}

export default FormSteps;
